"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.STICKYTYPES = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
exports.STICKYTYPES = {
    DYNAMICTOP: 'dynamicTop',
    DYNAMICBOTTOM: 'dynamicBottom',
    STATICTOP: 'staticTop',
    STATICBOTTOM: 'staticBottom',
};
// const ACCURACY = 5;
const MOUNT_RETRIES = 0;
const MAX_MOUNT_RETRIES = 10;
// genera la clase que controla
const generateStickyClassName = ({ type, className, fixed }) => {
    let stickyClass = `Sticky ${className}`;
    switch (type) {
        case exports.STICKYTYPES.DYNAMICTOP:
            stickyClass = `${stickyClass} dynamicTop`;
            if (fixed) {
                stickyClass = `${stickyClass} fixed-sticky`;
            }
            break;
        case exports.STICKYTYPES.DYNAMICBOTTOM:
            stickyClass = `${stickyClass} dynamicBottom`;
            if (fixed) {
                stickyClass = `${stickyClass} fixed-sticky`;
            }
            break;
        case exports.STICKYTYPES.STATICTOP:
            stickyClass = `${stickyClass} staticTop`;
            break;
        case exports.STICKYTYPES.STATICBOTTOM:
            stickyClass = `${stickyClass} staticBottom`;
            break;
        default:
            console.warn('Type is not defined into STICKYTYPES enum, please use one value from that ENUM');
            return null;
    }
    // console.log('[Sticky]: Nuevo render con: ', stickyClass);
    return stickyClass;
};
// aplica paddings al border
const applyDocumentPadding = ({ type, fixed, height }) => {
    try {
        switch (type) {
            case exports.STICKYTYPES.DYNAMICTOP:
                if (fixed) {
                    document.body.style.paddingTop = `${height}px`;
                }
                else {
                    document.body.style.paddingTop = 0;
                }
                break;
            case exports.STICKYTYPES.DYNAMICBOTTOM:
                if (fixed) {
                    document.body.style.paddingBottom = `${height}px`;
                }
                else {
                    document.body.style.paddingBottom = 0;
                }
                break;
            default:
                break;
        }
    }
    catch (error) {
        // seguramente estes en server
        // console.error(error);
    }
};
class Sticky extends react_1.Component {
    constructor() {
        super();
        this.handleScroll = () => {
            const { type } = this.props;
            const { fixed } = this.state;
            let landing = false;
            const currentScrollY = parseInt(window.scrollY, 10);
            // const diff = Math.abs(currentScrollY - lastScrollY);
            // const accuracyFlag = diff > ACCURACY || currentScrollY <= 0;
            const belowHeightCnd = currentScrollY >= this.height;
            const aboveHeightCnd = currentScrollY <= this.height;
            let newFixed = fixed;
            if (!fixed && belowHeightCnd) {
                newFixed = true;
            }
            if (fixed && aboveHeightCnd) {
                newFixed = false;
                landing = true;
            }
            const newFixedDiferentThanLast = newFixed !== fixed;
            if (newFixedDiferentThanLast) {
                this.setState({
                    fixed: newFixed,
                    landing,
                    height: this.height,
                });
            }
        };
        this.state = {
            fixed: false,
        };
    }
    componentDidMount() {
        const { type } = this.props;
        const interval = setInterval(() => {
            const el = document.querySelector('.Sticky');
            let heightAux = 0;
            if (el) {
                heightAux = el.getBoundingClientRect().bottom || el.offsetHeight;
                if (type !== exports.STICKYTYPES.STATICBOTTOM &&
                    type !== exports.STICKYTYPES.STATICTOP) {
                    this.height = heightAux;
                }
                else if (type === exports.STICKYTYPES.STATICTOP) {
                    document.body.style.paddingTop = `${this.height}px`;
                }
                else if (type === exports.STICKYTYPES.STATICBOTTOM) {
                    document.body.style.paddingBottom = `${this.height}px`;
                }
            }
            if (MOUNT_RETRIES >= MAX_MOUNT_RETRIES || this.height) {
                clearInterval(interval);
                this.handleScroll();
                window.addEventListener('scroll', this.handleScroll, { passive: true });
            }
        }, 10);
        window.scrollTo(0, 0);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }
    componentWillUnmount() {
        try {
            window.removeEventListener('scroll', this.handleScroll);
        }
        catch (error) {
            // console.error(error);
        }
    }
    render() {
        const { children, type, className } = this.props;
        const { fixed, landing, height } = this.state;
        const stickyClass = generateStickyClassName({ type, className, fixed });
        applyDocumentPadding({ type, fixed, height });
        return react_1.default.createElement("div", { className: `${stickyClass}${landing || ''}` }, children);
    }
}
Sticky.propTypes = {
    className: prop_types_1.default.string,
    children: prop_types_1.default.node.isRequired,
    type: prop_types_1.default.string,
};
Sticky.defaultProps = {
    type: exports.STICKYTYPES.DYNAMICTOP,
    className: '',
};
exports.default = Sticky;
//# sourceMappingURL=index.js.map